export default "__VITE_ASSET__78408aa6__"